<div class="grid gap-4 w-full" [ngClass]="gridRow">
  @for(cardData of filteredCardDetails; track cardData) {
  <mat-card
    class="relative py-5 flex flex-col items-center justify-center text-center font-semibold h-auto overflow-hidden shadow-2xl">
    <!-- Card Logo -->
    <mat-card-header
      class="flex flex-col sm:flex-row items-center justify-center text-center text-xl text-mdPrimary-500">
      @if(cardData.logo) {
      <img [src]="cardData.logo" alt="Logo" class="size-10" />
      } @else{
      <mat-icon class="text-[2.85rem]">{{ cardData.iconName }}</mat-icon>
      <!-- Material icon -->
      }
    </mat-card-header>

    <!-- Card Title -->
    <mat-card-content>
      <p class="text-lg font-semibold">{{ cardData.title }}</p>
    </mat-card-content>


    <mat-card-title class="font-semibold">
      {{ cardData.count }}
    </mat-card-title>

    <!-- Bottom Right Logo with Low Opacity -->
    <mat-card-header>
      <div *ngIf="!isdashboardpage">
        @if(cardData.logo) {
        <img [src]="cardData.logo" alt="Logo" class="absolute bottom-[-0.8rem] right-[-0.3rem] opacity-20 size-14" />
        } @else{
        <mat-icon class="absolute bottom-[-0.9rem] right-[-0.7rem] opacity-20 text-[4rem]">{{ cardData.iconName
          }}</mat-icon>
        <!-- Material icon -->
        }
      </div>
    </mat-card-header>
  </mat-card>
  }
</div>